import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'xp-rules',
    template: `
        <h2>Какви са правилата?</h2>
        <div class="row">
            <div class="col-sm-4">
                <h3>Стъпка #1</h3>
                <p>
                    Определяш колко време за самообучение можеш да отделяш дневно.
                </p>
            </div>
            <div class="col-sm-4">
                <h3>Стъпка #2</h3>
                <p>Получаваш списък с ресурси за самообучение (TODO-та).
                Всяко TODO има срок,
                съобразен времето, което можеш да отделяш на ден.</p>
         </div>
            <div class="col-sm-4">
                <h3>Стъпка #3</h3>
                <p>В края на всяко TODO има малък challenge -
                отговор на отворен въпрос, микро-проект
                или кратък въпросник (със затворени въпроси).</p>
            </div>
        </div>
        <h3>Как се оценява?</h3>
        <p>
            Получаваш точки за опитът, който трупаш (Experience Points).
            Те се разпределят по следния начин:
        </p>
        <ul>
            <li>Всяко TODO е планирано да бъде завършено за определен брой часове.
            Успешно завършено TODO ти носи по 10 точки за всеки час.</li>
            <li>За всяко завършено на време TODO, получаваш 2 точки;</li>
            <li>Имаш възможност да получиш бонус точки.</li>
        </ul>
    `
})
export class RulesComponent {

    constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/home/rules.component.ts